/* eslint-disable jsx-a11y/anchor-is-valid */
import { useAuth0 } from "@auth0/auth0-react";
import MyModal from "components/MyModal";
import Tabs from "components/Tabs";
import { SubHeader } from "layout/SubHeader";
import AuthService from "Lib/API/Auth";
import { addAllContacts } from "pages/School/Classes/classSlice";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import PaidRequests from "./PaidRequests";
import PaymentRequestFilter from "./PaymentRequestfilter";
import PaymentTable from "./paymentsRequests";

const PaymentsRequest = () => {
  const [openModal, setOpenModal] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [memberRequests, setMemberRequests] = useState([]);
  const [selected, setSelected] = useState([]);
  const [payLoading, setPayLoading] = React.useState(false);
  const [printClicked, setPrintClicked] = useState(false);
  const [exportClicked, setExportClicked] = useState(false);
  const [refresh, setRefresh] = React.useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const [value, setValue] = useState();
  const { contacts } = useSelector((state) => state?.data);
  const dispatch = useDispatch();
  const [colToCsv, setColToCsv] = useState([]);
  const [toCsv, setToCsv] = useState([]);

  React.useEffect(() => {
    async function fetchMyAPI() {
      const token = await getAccessTokenSilently();
      await AuthService.getAccount(token)
        .then((res) => {
          if (res) {
            const result = [];
            res.contacts.map((item) => {
              result.push({
                value: item?._id,
                label: item?.first_name + " " + item?.last_name,
              });
              return item;
            });
            dispatch(addAllContacts(result));
          }
        })
        .catch((err) => {
          toastr.error("Error", err?.data?.message);

        });
    }
    if (contacts?.length === 0) fetchMyAPI();
  }, []);

  return (
    <div className="school-classes pr-12 pt-5">
      <div className="header">
        <div className="header-tittle">
          <SubHeader
            className="subheader"
            {...{
              title: "Payment Request",
            }}
          />
        </div>
      </div>
      <div>
        <Tabs
          tabs={[
            {
              title: "Active Payment Requests",
              content: (
                <>
                  <PaymentRequestFilter
                    colToCsv={colToCsv}
                    toCsv={toCsv}
                    setExportClicked={setExportClicked}
                    exportClicked={exportClicked}
                    setPayLoading={setPayLoading}
                    payLoading={payLoading}
                    selected={selected}
                    setMemberRequests={setMemberRequests}
                    value={value}
                    setValue={setValue}
                    status="unpaid"
                    setPrintClicked={setPrintClicked}
                    printClicked={printClicked}
                    setRefresh={setRefresh}
                    refresh={refresh}
                  />
                  <PaymentTable
                    setToCsv={setToCsv}
                    setColToCsv={setColToCsv}
                    payLoading={payLoading}
                    setSelected={setSelected}
                    memberRequests={memberRequests}
                    setPrintClicked={setPrintClicked}
                    setExportClicked={setExportClicked}
                    exportClicked={exportClicked}
                    printClicked={printClicked}
                    value={value}
                    refresh={refresh}
                  />
                </>
              ),
            },
            {
              title: "Archived Payment Requests",
              content: (
                <>
                  <PaymentRequestFilter
                    value={value}
                    setValue={setValue}
                    status="paid"
                  />
                  <PaidRequests value={value} />
                </>
              ),
            },
          ]}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          type="secondary"
        ></Tabs>
      </div>
      <MyModal
        className="add-ledger-modal"
        open={openModal}
        onClose={() => {
          setOpenModal(false);
        }}
      ></MyModal>
    </div>
  );
};

export default PaymentsRequest;
